import { atom, getDefaultStore } from "jotai";
import { type HireNotReadyReason, hireNotReadyReasonFrom } from "./hireReadiness";

/** Set when a Hire action is refused because the location can't hire yet, for pages that hadn't loaded `hire_readiness`. */
export const hireNotReadyAtom = atom<HireNotReadyReason | null>(null);

/** For the app's mutation error handler: opens the explanation when `error` is a refused Hire action, else nothing. */
export const reportHireNotReady = (error: unknown) => {
  const reason = hireNotReadyReasonFrom(error);
  if (reason) getDefaultStore().set(hireNotReadyAtom, reason);
};
